import React from 'react';
import { Avatar, Box, ListItem } from '@mui/material';

import { Chip } from 'components/Chip';
import { Employee } from 'containers/CommunityPage/EmployeeSearch/UserMultiSelect';

export type MemberDisplayProps = {
  communityId: string;
  onClick: () => void;
  user: Employee;
};

export const MemberDisplay = ({ communityId, onClick, user }: MemberDisplayProps) => {
  const name = [user.fullName?.first, user.fullName?.last].filter(Boolean).join(' ').trim();
  const alreadyMember = user.communities.some((c) => communityId === c.communityId);
  return (
    <ListItem
      key={user.id}
      style={{ display: 'flex', alignItems: 'center', gap: 10 }}
      onClick={alreadyMember ? undefined : onClick}
      disabled={alreadyMember}
    >
      {user.mainPicture && (
        <Avatar alt={name} src={user.mainPicture} style={{ width: 36, height: 36 }} />
      )}
      <Box flex="1 1 auto">
        {name} <span style={{ color: '#676767' }}>{user.organizationDepartment}</span>
      </Box>
      <Box
        style={{
          marginLeft: 'auto',
          display: 'flex',
          gap: '5px 20px',
          flexWrap: 'wrap',
          flex: '1 1 auto',
          justifyContent: 'end',
        }}
      >
        {alreadyMember && <Chip label="Member" style={{ borderRadius: 0 }} size="small" />}
      </Box>
    </ListItem>
  );
};
